type FormatSignInMessageParams = {
  address: string;
  blockchainName: string;
  chainId?: string;
  domain: string;
  issuedAt?: string;
  nonce: string;
  requestId?: string;
  resources?: string[];
  statement?: string;
  uri: string;
};

/**
 * Formats a sign in message to prove ownership of an address.
 */
export const formatSignInMessage = async ({
  domain,
  blockchainName,
  address,
  uri,
  chainId,
  nonce,
  issuedAt,
  requestId,
  statement,
  resources,
}: FormatSignInMessageParams) => {
  // This format follows the sign-in with ethereum (SIWE) standard,
  // but we are using it also for non-ethereum wallets for now (eg. Solana)
  // for more context on format and fields, please see:
  // https://docs.login.xyz/general-information/siwe-overview/eip-4361
  const header = `${domain} wants you to sign in with your ${blockchainName} account:`;
  const prefix = [header, address].join('\n');

  // If there is a statement, we want to add a gap between the prefix and the statement
  // two times '\n', first to move statement to next line and second to add a gap between prefix and statement
  const prefixWithStatementGap = statement ? '\n\n' : '\n';
  const prefixWithStatement = `${[prefix, statement].join(
    prefixWithStatementGap
  )}\n`;

  const suffixFields: string[] = [];
  suffixFields.push(`URI: ${uri}`);
  suffixFields.push('Version: 1');
  if (chainId) {
    suffixFields.push(`Chain ID: ${chainId}`);
  }

  suffixFields.push(`Nonce: ${nonce}`);

  if (issuedAt) {
    suffixFields.push(`Issued At: ${issuedAt}`);
  }

  if (requestId) {
    suffixFields.push(`Request ID: ${requestId}`);
  }

  if (resources?.length) {
    suffixFields.push(
      `Resources:${resources.map((resource) => '\n- ' + resource).join()}`
    );
  }

  const suffix = suffixFields.join('\n');

  return [prefixWithStatement, suffix].join('\n');
};
